import React, { useContext, useState } from 'react'
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Popover,
  Button,
} from '@mui/material'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import MenuIcon from '@mui/icons-material/Menu'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { useDispatch, useSelector } from 'react-redux'
import {logoutAuthSession} from '../../redux/features/authSlice'
import { useNavigate } from 'react-router-dom'
import { Stack } from 'react-bootstrap'
import assets from '../../assets'
import Box from '@mui/material/Box'
import { useMediaQuery } from '@mui/material'
import ProfileModal from './ProfileModal'
import { apiConfig } from '../../api/ApiConfig'
import { UserDetailContext } from '../../context/UserDetailContext'

const { getUserDetailById } = apiConfig()

const Topbar = ({ toggleSidebar, text }) => {
  const [logoutPopupOpen, setLogoutPopupOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isSmallScreen = useMediaQuery('(max-width:768px)')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const userDetailContext = useContext(UserDetailContext)
  const { userId, isAuthenticated, isTokenAuth } = useSelector((state) => state.auth)

  const refreshUserDetailContext = async () => {
    const userDetailResponse = await getUserDetailById(userId)
    userDetailContext.updateUserDetail(userDetailResponse)
  }

  const handleProfileOpen = async () => {
    await refreshUserDetailContext()
    setIsModalOpen(true)
    handleCloseLogoutPopup() // Close the popover when opening the modal
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    handleCloseLogoutPopup()
  }

  const handleLogoutClick = (event) => {
    setAnchorEl(event.currentTarget)
    setLogoutPopupOpen(true)
  }

  const handleCloseLogoutPopup = () => {
    setAnchorEl(null)
    setLogoutPopupOpen(false)
  }

  const handleLogout = () => {
    // Perform logout action
    dispatch(logoutAuthSession())
    navigate('/login')
    handleCloseLogoutPopup()
  }

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Stack sx={{ width: '100%' }} direction="row" justifyContent="center">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {isAuthenticated && isSmallScreen ? (
              <MenuIcon sx={{ cursor: 'pointer' }} onClick={toggleSidebar} />
            ) : null}
            <img src={assets.images.logo} alt="Ultracutecals" width={250} />
          </Box>
        </Stack>
        <Typography variant="h6" component="div">
          {text}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isAuthenticated && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<MenuBookIcon fontSize="small" />}
              onClick={() => navigate('/docs')}
              sx={{
                color: '#ffffff',
                borderColor: 'rgba(255,255,255,0.55)',
                fontWeight: 700,
                textTransform: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  borderColor: '#ffffff',
                  backgroundColor: 'rgba(255,255,255,0.12)',
                },
              }}
            >
              Docs
            </Button>
          )}
          {isAuthenticated && !isTokenAuth && (
            <div>
              <Popover
                open={logoutPopupOpen}
                anchorEl={anchorEl}
                onClose={handleCloseLogoutPopup}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '5px 10px',
                    alignItems: 'flex-start',
                  }}
                >
                  <Button
                    onClick={handleProfileOpen}
                    sx={{ color: 'primary', fontWeight: 'bold' }}
                  >
                    Profile
                  </Button>
                  <Button
                    onClick={handleLogout}
                    sx={{ color: 'primary', fontWeight: 'bold' }}
                  >
                    Sign Out
                  </Button>
                </Box>
              </Popover>
              <ProfileModal
                isModalOpen={isModalOpen}
                handleModalClose={handleModalClose}
              />
              <IconButton
                color="inherit"
                onClick={handleLogoutClick}
                sx={{ marginLeft: 'auto' }}
              >
                <AccountCircleIcon />
              </IconButton>
            </div>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default Topbar
